<script>
    import "./partnerSection.css"
    import { Swiper, SwiperSlide } from 'swiper/svelte'
    import 'swiper/css/pagination'
    import 'swiper/css/navigation'
    import 'swiper/css'
    import { partnerSliderOptions } from '../../../constants/constants'
    let image1 = "./images/partner1.png";
    let partnerSection = [
        {
            partnerImage: "./images/partner5.png",
            alt: "nitro league",
            link: "https://nitroleague.com/"
        },
        {
            partnerImage: "./images/partner1.png",
            alt: "kawaii image",
            link: "https://kawaii.global/",
        },
        {
            partnerImage: "./images/partner3.png",
            alt: "shark club",
            link: "https://sharkrace.com/"
        },
        {
            partnerImage: "./images/partner4.png",
            alt: "bulliverse",
            link: "https://bullieverisland.com/"
        },
    ];
</script>
<div class="partner-slider-wrapper flex">
    <div class="container">
        <div class="p-slider-wrapper">
            <Swiper
                    slidesPerView={partnerSliderOptions.slidesPerView}
                    spaceBetween={partnerSliderOptions.spaceBetween}
                    slidesPerGroup={partnerSliderOptions.slidesPerGroup}
                    loop={partnerSliderOptions.loop}
                    pagination={partnerSliderOptions.pagination}
                    navigation={partnerSliderOptions.navigation}
                    modules={partnerSliderOptions.modules}
                    breakpoints={partnerSliderOptions.breakPoint}
                    class="mySwiper">
                {#each partnerSection as image, index}
                    <SwiperSlide>
                        <div class="partner-image">
                            <a href={image.link} target="_blank" rel="noreferrer">
                                <img class="img-responsive" src={image.partnerImage} alt={image.alt} />
                            </a>
                        </div>
                    </SwiperSlide>
                {/each}
            </Swiper>
        </div>
    </div>
</div>